import React, { useState } from 'react';
import { Modal } from './ui/Modal';
export function Footer() {
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  return <>
      <footer className="py-12 bg-[#0f172a] border-t border-white/5" data-id="element-9">
        <div className="max-w-4xl mx-auto px-4 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-10">
          <p className="text-slate-600 text-sm" data-id="element-11">
            © {new Date().getFullYear()} Reset de Ansiedad. Todos los derechos
            reservados.
          </p>

          <div className="flex items-center gap-6" data-id="element-12">
            <button onClick={() => setPrivacyOpen(true)} className="text-slate-500 hover:text-[#d4a574] text-sm transition-colors" data-id="element-13">
              Política de Privacidad
            </button>
            <button onClick={() => setTermsOpen(true)} className="text-slate-500 hover:text-[#d4a574] text-sm transition-colors" data-id="element-14">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <Modal isOpen={privacyOpen} onClose={() => setPrivacyOpen(false)} title="Política de Privacidad" data-id="element-15">
        <div className="space-y-6 text-slate-300" data-id="element-16">
          <p className="text-sm text-slate-400" data-id="element-17">
            Última actualización:{' '}
            {new Date().toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
          </p>

          <section data-id="element-18">
            <h3 className="text-lg font-serif text-white mb-3" data-id="element-19">
              1. Información que Recopilamos
            </h3>
            <p data-id="element-20">
              Recopilamos información que nos proporcionas directamente cuando
              realizas una compra, incluyendo tu nombre, dirección de correo
              electrónico y datos de pago. Los pagos son procesados de forma
              segura a través de proveedores de pago externos.
            </p>
          </section>

          <section data-id="element-21">
            <h3 className="text-lg font-serif text-white mb-3" data-id="element-22">
              2. Uso de la Información
            </h3>
            <p data-id="element-23">Utilizamos la información recopilada para:</p>
            <ul className="list-disc list-inside mt-2 space-y-1 text-slate-400" data-id="element-24">
              <li data-id="element-25">Procesar y entregar tu compra</li>
              <li data-id="element-26">Enviarte actualizaciones sobre tu pedido</li>
              <li data-id="element-27">Responder a tus consultas y solicitudes</li>
              <li data-id="element-28">Mejorar nuestros productos y servicios</li>
            </ul>
          </section>

          <section data-id="element-29">
            <h3 className="text-lg font-serif text-white mb-3" data-id="element-30">
              3. Protección de Datos
            </h3>
            <p data-id="element-31">
              Implementamos medidas de seguridad técnicas y organizativas para
              proteger tu información personal contra acceso no autorizado,
              alteración, divulgación o destrucción.
            </p>
          </section>

          <section data-id="element-32">
            <h3 className="text-lg font-serif text-white mb-3" data-id="element-33">4. Cookies</h3>
            <p data-id="element-34">
              Utilizamos cookies esenciales para el funcionamiento del sitio web
              y cookies analíticas para entender cómo los visitantes interactúan
              con nuestro sitio.
            </p>
          </section>

          <section data-id="element-35">
            <h3 className="text-lg font-serif text-white mb-3" data-id="element-36">
              5. Tus Derechos
            </h3>
            <p data-id="element-37">
              Tienes derecho a acceder, rectificar o eliminar tu información
              personal. También puedes oponerte al procesamiento de tus datos o
              solicitar la portabilidad de los mismos.
            </p>
          </section>

          <section data-id="element-38">
            <h3 className="text-lg font-serif text-white mb-3" data-id="element-39">
              6. Cambios en esta Política
            </h3>
            <p data-id="element-40">
              Podemos actualizar esta política de privacidad ocasionalmente. Te
              notificaremos sobre cualquier cambio publicando la nueva política
              en esta página.
            </p>
          </section>
        </div>
      </Modal>

      {/* Terms and Conditions Modal */}
      <Modal isOpen={termsOpen} onClose={() => setTermsOpen(false)} title="Términos y Condiciones" data-id="element-41">
        <div className="space-y-6 text-slate-300" data-id="element-42">
          <p className="text-sm text-slate-400" data-id="element-43">
            Última actualización:{' '}
            {new Date().toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
          </p>

          <section data-id="element-44">
            <h3 className="text-lg font-serif text-white mb-3" data-id="element-45">
              1. Aceptación de los Términos
            </h3>
            <p data-id="element-46">
              Al acceder y utilizar este sitio web y realizar una compra,
              aceptas estar sujeto a estos términos y condiciones de uso.
            </p>
          </section>

          <section data-id="element-47">
            <h3 className="text-lg font-serif text-white mb-3" data-id="element-48">
              2. Producto Digital
            </h3>
            <p data-id="element-49">
              "Reset de Ansiedad en 14 Noches" es un producto digital (ebook)
              que se entrega electrónicamente. Una vez completada la compra,
              recibirás acceso inmediato al contenido.
            </p>
          </section>

          <section data-id="element-50">
            <h3 className="text-lg font-serif text-white mb-3" data-id="element-51">
              3. Uso Personal
            </h3>
            <p data-id="element-52">
              El contenido adquirido es para uso personal únicamente. Queda
              prohibida la reproducción, distribución, modificación o reventa
              del material sin autorización expresa.
            </p>
          </section>

          <section data-id="element-53">
            <h3 className="text-lg font-serif text-white mb-3" data-id="element-54">
              4. Garantía de Satisfacción
            </h3>
            <p data-id="element-55">
              Ofrecemos una garantía de satisfacción de 14 días. Si el protocolo
              no te ayuda, puedes solicitar un reembolso completo dentro de este
              período.
            </p>
          </section>

          <section data-id="element-56">
            <h3 className="text-lg font-serif text-white mb-3" data-id="element-57">
              5. Descargo de Responsabilidad
            </h3>
            <p data-id="element-58">
              Este producto es de carácter informativo y educativo. No sustituye
              el consejo médico profesional. Si experimentas problemas de salud
              mental severos, te recomendamos consultar con un profesional de la
              salud.
            </p>
          </section>

          <section data-id="element-59">
            <h3 className="text-lg font-serif text-white mb-3" data-id="element-60">
              6. Propiedad Intelectual
            </h3>
            <p data-id="element-61">
              Todo el contenido, incluyendo textos, gráficos, logos y materiales
              descargables, está protegido por derechos de autor y es propiedad
              exclusiva de Reset de Ansiedad.
            </p>
          </section>

          <section data-id="element-62">
            <h3 className="text-lg font-serif text-white mb-3" data-id="element-63">
              7. Modificaciones
            </h3>
            <p data-id="element-64">
              Nos reservamos el derecho de modificar estos términos en cualquier
              momento. Los cambios entrarán en vigor inmediatamente después de
              su publicación en el sitio web.
            </p>
          </section>
        </div>
      </Modal>
    </>;
}